export const faq = [
  {
    q: "Je suis débutant complet, est-ce possible ?",
    a: "Oui, absolument. La grande majorité de mes élèves commencent de zéro. On part toujours des bases, sans pression, et à votre rythme.",
  },
  {
    q: "Peut-on préparer une ouverture de bal de mariage ?",
    a: "Bien sûr. C'est l'une de mes spécialités. On choisit ensemble votre musique, et je construis une chorégraphie adaptée à votre niveau et à l'ambiance souhaitée.",
  },
  {
    q: "Combien de cours faut-il pour apprendre une chorégraphie ?",
    a: "En général, 4 à 8 cours suffisent pour une ouverture de bal mémorable. Tout dépend du temps disponible avant le mariage et de votre objectif.",
  },
  {
    q: "Où ont lieu les cours ?",
    a: "Au domicile, dans une salle louée ou dans un lieu public. Je me déplace partout en France et au Luxembourg ; des frais de déplacement sont à prévoir selon la zone.",
  },
  {
    q: "Peut-on venir en couple ?",
    a: "Oui, c'est même la formule la plus courante. Le tarif est identique : 80 € de l'heure pour le couple.",
  },
  {
    q: "Proposez-vous des cours collectifs ?",
    a: "Oui, pour des groupes constitués (amis, EVG/EVJF, événements d'entreprise, soirées de mariage). Le tarif s'adapte selon le nombre et le format.",
  },
  {
    q: "Quels styles enseignez-vous ?",
    a: "Rock, valse, rock acrobatique, danse de salon, danse de mariage et line dance. Tous les niveaux sont les bienvenus.",
  },
  {
    q: "Quels sont les tarifs ?",
    a: "80 €/h pour un cours individuel ou en couple. Pack 5h : 370 €. Pack 10h : 720 €. Déplacement +10 € selon la zone.",
  },
  {
    q: "Comment réserver ?",
    a: "Le plus simple : remplir le formulaire de contact ci-dessous. Je vous réponds personnellement sous 6h en moyenne.",
  },
];
